/**
 * @file After successful message archive mutation, update the cache
 */

import { UpdateResolver } from '@urql/exchange-graphcache';

import {
  MessageArchiveMutation,
  MessageArchiveMutationVariables,
  MessagesDocument,
} from '../../../../../generated/graphql';
import { removeTask } from '../utils/updaters/messages/tasks';
import paginatedQueryDeletion from '../utils/updaters/paginatedQueryDeletion';
import { removeNodeFromPaginatedQuery } from '../utils/updaters/paginatedQueryHelpers';

/**
 * After successful archive request this function removes the message
 * from graphql cache.
 *
 * @param _result      The result of the mutation (unused)
 * @param variables    The variables passed along with the mutation
 * @param variables.id The ID of the archived message
 * @param cache        Current GraphQL cache
 */
const messageArchiveMutation: UpdateResolver<
  MessageArchiveMutation,
  MessageArchiveMutationVariables
> = (_result, { id: messageId }, cache) => {
  paginatedQueryDeletion({
    cache,
    queryName: 'messages',
    /**
     * Remove node from paginated query
     *
     * @param variables Variables used in the query
     */
    updateQuery: variables => {
      removeNodeFromPaginatedQuery({
        cache,
        nodeId: messageId,
        query: MessagesDocument,
        queryName: 'messages',
        variables,
      });
    },
  });

  removeTask(messageId, cache);
};

export default messageArchiveMutation;
